import styled from "styled-components";

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 95%;
`;

export const Header = styled.div`
    padding-top: 15px;
    padding-left: 20px;
    padding-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    color: #616161;
    display: flex;
    flex-direction: column;
`;

export const Body = styled.div`
    margin-left: 70px;
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Toggle = styled.div`
    padding: 5px;
    cursor: pointer;
    opacity: 0.6;
    outline: 0;
    border: none;
    transition: ease border-bottom 250ms;
    width: 50px;
    height: 100%;
    background-color: #FAFAFA;
    color: #616161;
    border-radius: 7px;
    &:hover {
        transition: all 0.3s ease-in-out;
        background-color: #d2d2d2;
    }
    text-align: center;
    ${({ toggle }) =>
        toggle &&
        `
        background-color: #616161;
        color: white;
        opacity: 1;
        &:hover {
            transition: all 0.3s ease-in-out;
            background-color: #616161;
        }
        `
    }
`;